import React, {Component} from 'react';
import axios from "axios";
import Button from "react-bootstrap/Button";

import classes from'./NewGameType.module.css';
import Form from "react-bootstrap/Form";
import apiUrl from "../../../shared/config";

class NewGameType extends Component  {
    state = {
        game_types: [],
        game_type: {
            game_type_id: null,
            game_type_name: '',
            game_type_notes: ''
        }
    };

    componentDidMount() {
        if (this.props.game_types !== []) {
            this.setState({game_types: this.props.game_types});
        }
    }

    addHandler = () => {
        this.postDataHandler(null);
        this.props.newGameTypeToggle();
    };

    postDataHandler = () => {
        const post = {
            "game_type_id": this.state.game_type.game_type_id,
            "game_type_name": this.state.game_type.game_type_name,
            "game_type_notes": this.state.game_type.game_type_notes,
        };
        axios.post(apiUrl +'GameTypes/set', post)
            .then(response => {
                this.props.onNewGameType(response.data);
            });
        this.setState({
            "game_type": {
                game_type_id: null,
                game_type_name: '',
                game_type_notes: ''
            }
        });

    };

    render() {
        return (
            <>
                <dd className={"col-sm-9"}>
                    <div className={classes.NewGameTypesBlock}>
                        <div>
                            <Form.Control
                                type="text"
                                placeholder="Enter the name of the game type you want to create."
                                value={this.state.game_type.game_type_name}
                                onChange={(event) => this.setState({game_type: {...this.state.game_type, game_type_name: event.target.value}})}
                            />
                            <Form.Control
                                as="textarea"
                                rows="4"
                                placeholder="Include a paragraph or so long description of the game type."
                                value={this.state.game_type.game_type_notes}
                                onChange={(event) => this.setState({game_type: {...this.state.game_type, game_type_notes: event.target.value}})}
                            />
                        </div>
                        <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newGameTypeToggle}>Cancel</Button>
                        <Button className="col-sm-3" variant="outline-primary" onClick={
                            this.addHandler
                        }>Submit</Button>
                    </div>
                </dd>
                <dt className="col-sm-3"> </dt>
            </>
        );
    }
}

export default NewGameType;